import gql from 'graphql-tag';
import lowerFirst from 'lodash.lowerfirst';

const ARTICLE_QUERIES = ['getArticle', 'getPublishedArticle'];

const YACHT_QUERIES = [
  'getPublishedYachtForCharter',
  'getPublishedYachtForSale',
  'getPublishedYachtPage',
  'getYachtForCharter',
  'getYachtForSale',
  'getYachtPage'
];

const getYachtProperties = queryName => {
  if (YACHT_QUERIES.indexOf(queryName) === -1) {
    return '';
  }

  return `
    length_overall
    built_on_year
    publishedBuilderProfiles {
      name
    }
  `;
};

const getExhibitorProperties = queryName => {
  if ([...ARTICLE_QUERIES, ...YACHT_QUERIES].indexOf(queryName) === -1) {
    return '';
  }

  return `
    publishedExhibitors {
      name
    }
  `;
};

const keyBuilder = queryName => {
  const [, key] = queryName.split('getPublished');
  const formattedKey = lowerFirst(key);

  return formattedKey.concat('Id');
};

const getContactDataQuery = queryName => gql`
  query getContactData($id: String!) {
    data: ${queryName}(id: $id) {
      id
      name
      ${keyBuilder(queryName)}: id
      ${getYachtProperties(queryName)}
      ${getExhibitorProperties(queryName)}
      ${queryName === 'getPublishedBroker' ? 'website' : ''}
      category {
        id
        name
      }
      image {
        id
        filename
        url
      }
      businessContactComponentContacts {
        brokerBranchId
        exhibitorId
        image {
          id
          url
          data
          name
        }
        name
        phone
        website
      }
    }
  }
`;

export default getContactDataQuery;
